export const API_STATUS_TYPE  = Object.freeze({
    IDLE: "idle",
    PENDING: "pending",
    SUCCESSED: "successed",
    FAILED: "failed"
})